import CSS from './index.module.scss';

export interface DotProps {
  color: string;
}

export function Dot({ color }: DotProps) {
  return <div className={CSS.root} style={{ backgroundColor: color }} />;
}
